import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export async function blockAffectedStaffTravelExpenses(affectedStaffId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.affectedStaffs.blockAffectedStaffTravelExpenses.url, {
        id: affectedStaffId
      })
    )
    .post()
}

export async function unblockAffectedStaffTravelExpenses(affectedStaffId: number) {
  return restApiClient
    .url(
      constructApiUrl(API.affectedStaffs.unblockAffectedStaffTravelExpenses.url, {
        id: affectedStaffId
      })
    )
    .post()
}
